import MyScreenFunc from '@/pcomponents/common/screen/func/screen_func';
import strFunc from "@/lib/lyg/string";
import TopYearMonthArea from "@/pcomponents/common/crud/calendar/area/top_year_month";
import attend_late_active_ico from "@/img/ico/attend/attend_late_active.png";
import attend_late_ico from "@/img/ico/attend/attend_late.png";
import attend_o_active_ico from "@/img/ico/attend/attend_o_active.png";
import attend_o_ico from "@/img/ico/attend/attend_o.png";
import attend_x_active_ico from "@/img/ico/attend/attend_x_active.png";
import attend_x_ico from "@/img/ico/attend/attend_x.png";

function SearchSubArea(props: any) {
  let myProps = {
    listOpt: {},
    openAttendPopup: (inData: any) => { },
    list: (inData: any) => { },
    navigate: (inData: any) => { },
    is_print_land: false,
    set_is_print_land: (inData: any) => { },
    is_able_save_daily_report: false,
    on_check_all: (inData: any) => { },
    onClickPrint: (inData: any) => { },
    onClickExcelDown: (inData: any) => { },
    sms_phone_check: "",
    set_sms_phone_check: (inData: any) => { },
    is_check_show_textarea: true,
    set_check_is_show_textarea: (inData: any) => { },
    is_show_daily_prescribe: false,
    set_is_show_daily_prescribe: (inData: any) => { },
    open_sms_select_hp_by_user_popup: (inData: any) => { },
    save_daily_report_by_stu_arr: (inData: any) => { },
    delete_daily_report_by_stu_arr: (inData: any) => { },
    open_send_home_work_msg_popup: () => { },
    open_daily_report_text_popup: () => { },
    open_send_push_popup: () => { },
    ...props
  };
  let listOpt = myProps.listOpt;

  const get_attend_button_tags = () => {
    let attend_in_state_arr = [
      { "value": "attend", "text": "등원", "img": attend_o_ico, "img_active": attend_o_active_ico },
      { "value": "late", "text": "등원(지각)", "img": attend_late_ico, "img_active": attend_late_active_ico },
      { "value": "absent", "text": "결석", "img": attend_x_ico, "img_active": attend_x_active_ico },
      // { "value": "out", "text": "결석", "img": attend_out_ico, "img_active": attend_out_active_ico },
    ];
    let button_tags = attend_in_state_arr.map((item, index) => {
      return (
        <button key={index} className={"ml-1"}
          onClick={() => {
            myProps.openAttendPopup({
              attend_sort: "in",
              attend_sort_detail: item["value"],
            });
          }}>
          <img src={item.img} alt={item.text} style={{ height: "27px" }} />
        </button>
      );
    });
    return button_tags;
  };

  return (
    <div className="my_flex_between">
      <div>
        <div style={{ lineHeight: "30px", height: "30px" }}>
          <button className="btn-m btn-dark" style={{ background: "#ea5a2f" }}
            onClick={() => { myProps.open_daily_report_text_popup(); }}>데일리플랜상담</button>
        </div>
        <div className="my_flex_left" style={{ lineHeight: "30px", height: "30px" }}>
          <button className="btn btn-yellowish2" onClick={() => { myProps.open_sms_select_hp_by_user_popup(); }} >문자</button>
          <button className="btn btn-yellowish2" onClick={() => { myProps.open_send_push_popup(); }} >푸시</button>
          <span className="ml-2">
            {get_attend_button_tags()}
          </span>
          {myProps.is_able_save_daily_report &&
            <>
              <button className="btn btn-sky ml-2" onClick={(e: any) => { myProps.save_daily_report_by_stu_arr({}); }}>저장</button>
              <button className="btn btn-red" onClick={myProps.delete_daily_report_by_stu_arr} >삭제</button>
            </>
          }
        </div>
      </div>
      <div>
        <TopYearMonthArea
          select_date={listOpt.s_addon_daily_report_start_date}
          set_select_date={(inData: any) => {
            myProps.list({
              ...listOpt,
              s_addon_daily_report_start_date: inData,
              s_addon_daily_report_end_date: inData
            });
          }}
          center_y={false}
          center_m={true}
          center_d={true}
          left_right_text_period={"day"}
          is_show_month_arrow={false}
          is_show_day_arrow={true}
        ></TopYearMonthArea>
      </div>
      <div>
        <div className="my_flex_right" style={{ lineHeight: "30px", height: "30px" }}>
          <button className="btn-m btn-gray" onClick={() => { myProps.navigate("/comp/edu/daily_report/history_list"); }}>이력</button>
          <button className="btn-m btn-gray" onClick={() => { myProps.navigate("/comp/edu/daily_prescribe/history"); }}>처방이력</button>
        </div>
        <div className="my_flex_right" style={{ lineHeight: "30px", height: "30px" }}>
          <label>
            <input type="checkbox" className="search-input" value={"1"} name="is_show_daily_prescribe"
              checked={myProps.is_show_daily_prescribe}
              onChange={(e: any) => {
                myProps.set_is_show_daily_prescribe(e.target.checked);
              }} />
            <span className="ml-1">처방상세</span>
          </label>
          <label>
            <input type="checkbox" className="search-input ml-1" value={"1"} name="is_check_show_textarea"
              checked={myProps.is_check_show_textarea}
              onChange={(e: any) => {
                strFunc.set_storage("daily_report_is_check_show_textarea", e.target.checked ? "1" : "");
                myProps.set_check_is_show_textarea(e.target.checked);
              }} />
            <span className="ml-1">체크상세</span>
          </label>
          <button className="btn-s btn-yellowish2" onClick={myProps.onClickExcelDown}>엑셀</button>
          <select className="border" value={myProps.is_print_land ? "1" : ""}
            onChange={(e: any) => {
              let tmp_val = e.target.value;
              myProps.set_is_print_land(tmp_val == "1" ? true : false);
              strFunc.set_storage("daily_report_is_print_land", tmp_val);
            }} >
            <option value={""}>세로</option>
            <option value={"1"}>가로</option>
          </select>
          <button className="btn-s btn-yellowish2" onClick={myProps.onClickPrint}>프린트</button>
        </div>
      </div>
    </div>
  );
};
export default SearchSubArea;